import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import PersonOutline from "@mui/icons-material/PersonOutlineOutlined";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS, enAU } from "date-fns/locale";
import { format } from "date-fns";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TimeLoader } from "../_components/loaders/TimeLoader";
import TextMaskPhone from "../_components/TextMaskPhone";
import { BigButton } from "./Components/Buttons";
import moment from "moment-timezone";
// import { toast } from "react-toastify";
import { useToaster } from "../_components/toaster/MuiToasterProvider";
import { Link as RouterLink } from "react-router-dom";
import { SanitizeEmail } from "./utils/EmailUtils";
// Removing temporarily
// import { importScript } from "../_helpers/importScript";
import { LifeSafer } from "../_helpers/BrandConstants";
import {
  // Removing temporarily
  // validateReCaptcha,
  verifyEnrollee,
  verifyText,
  verifyEmail,
} from "../_api/usersApi";
import { UserVerify } from "../_api/registerApi";
import { updateClientEmail } from "../_api/profileApi";
import Cookies from "universal-cookie";
const iconStyling = {
  opacity: 0.6,
  color: "#1c355e",
  paddingRight: "5px",
};
const PersonalInformation = ({ handleNext, UpdateUserInfo }) => {
  const cookies = new Cookies();
  // Removing temporarily
  // importScript(
  //   `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}`
  // );
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const locale = countryCode === "USA" ? enUS : enAU;
  const { t } = useTranslation();
  const brandIdentifier = LifeSafer;
  const [disableInputs, setDisableInputs] = useState(false);
  const toast = useToaster();
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [existingEmail, setExistingEmail] = useState("");
  const [sanitizedExistingEmail, setSanitizedExistingEmail] = useState("");
  const [openPhoneDialog, setOpenPhoneDialog] = useState(false);
  const closePhoneDialog = () => {
    setOpenPhoneDialog(false);
  };
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const closeEmailDialog = () => {
    setOpenEmailDialog(false);
  };
  const [openVerificationDialog, setOpenVerificationDialog] = useState(false);
  const openVerification = () => {
    setOpenPhoneDialog(false); // close previous dialog before opening next.
    setOpenVerificationDialog(true);
  };
  const closeVerificationDialog = () => {
    setOpenVerificationDialog(false);
  };
  const [verificationCodeIncorrect, setVerificationCodeIncorrect] =
    useState(false);
  const [verificationCodeExpired, setVerificationCodeExpired] = useState(false);
  const validateVerificationCode = () => {
    let verificationInfo = {
      userId: userInfo.userID,
      resetCode: getValues("verificationCode"),
      brandIdentifier: brandIdentifier,
    };
    verifyEnrollee(verificationInfo)
      .then((verifyResponse) => {
        if (verifyResponse.message === "Invalid") {
          setValue("verificationCode", "");
          setVerificationCodeIncorrect(true);
        }
        if (verifyResponse.message === "Expired") {
          setValue("verificationCode", "");
          setVerificationCodeExpired(true);
        }
        if (verifyResponse.message === undefined) {
          // set verification info for jwt
          cookies.set("driveSaferUser", JSON.stringify(verifyResponse), {
            path: "/",
            sameSite: "strict",
          });
          updateClientEmail(userInfo)
            .then((response) => {
              console.info("Update Email Response", {
                response,
              });
              history.push({
                pathname: "/",
              });
            })
            .catch((error) => {
              console.error(t("registration.emailUpdateError"), error);
              toast.error(t("registration.emailUpdateError"));
              cookies.remove("driveSaferUser"); // remove cookie so failure to update does not 'log in' user.
            });
          closeVerificationDialog();
        }
      })
      .catch((error) => {
        console.error(error);
        showApiErrorToast();
      });
  };
  const showApiErrorToast = () => {
    toast.error(
      <div>
        <Typography
          variant="h6"
          style={{
            textDecoration: "underline",
          }}
        >
          {t("registration.apiErrorTitle")}
        </Typography>
        <Typography variant="body2">{t("registration.apiError")}</Typography>
      </div>,
    );
  };
  const showContactUsToast = () => {
    toast.warn(
      <div>
        <Typography
          variant="h6"
          style={{
            textDecoration: "underline",
          }}
        >
          {t("registration.contactUs")}
        </Typography>
        <Typography variant="body2">
          {t("registration.contactUsMessage")}
        </Typography>
      </div>,
      {
        autoClose: false,
      },
    );
  };
  // let phoneTypeList = [
  //   { label: t("registration.cellPhone"), abbrev: "Cell" },
  //   { label: t("registration.homePhone"), abbrev: "Home" },
  // ];
  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      // phoneTypeInfo: phoneTypeList[0],
      // phoneType: "cell",
    },
  });
  const submitPersonalInfo = (data) => {
    const normalizedEmail = data?.email?.trim();
    data.dob = format(new Date(data.dob), "yyyy/MM/dd").toString();
    setDisableInputs(true);
    setShowLoadingSpinner(true);
    let personalInformation = {
      BrandIdentifier: brandIdentifier,
      Email: normalizedEmail,
      FirstName: data.firstName,
      LastName: data.lastName,
      Phone: data?.cellPhone?.replace(/\D/g, ""),
      UserId: 0,
      DOB: data.dob,
    };
    // 'Honey Pot' to try to catch 'bots'
    // false means the box is not checked.
    if (data.call_me_out !== false) {
      toast.error(t("registration.honeyPotError"));
    } else {
      // Removing temporarily
      // TODO : Remove ReCaptcha Permanently?
      // window.grecaptcha.enterprise.ready(() => {
      //   window.grecaptcha.enterprise
      //     .execute(process.env.REACT_APP_RECAPTCHA_KEY, {
      //       action: "login",
      //     })
      //     .then((token) => {
      //       validateReCaptcha(token)
      //         .then((result) => {
      //           if (result.message === "Authorized") {

      UserVerify(personalInformation).then((verificationResponse) => {
        setUserInfo({
          clientID: verificationResponse.clientID,
          userID: verificationResponse.userID,
          email: normalizedEmail,
          // new email entered by user
          firstName: data.firstName,
          lastName: data.lastName,
          homePhone: data?.cellPhone?.replace(/\D/g, ""),
          cellPhone: data?.cellPhone?.replace(/\D/g, ""),
          // data.phoneType === "cell"
          // ? data.phoneNumber.replace(/\D/g, "")
          // : "",
        });
        setExistingEmail(verificationResponse.phoneNameEmail);
        UpdateUserInfo({
          brandIdentifier,
          ...data,
        });
        if (
          verificationResponse.emailExists === false &&
          verificationResponse.phoneNameExists === false
        ) {
          handleNext();
        }
        if (verificationResponse.emailExists === true) {
          setOpenEmailDialog(true);
          setDisableInputs(false);
          setShowLoadingSpinner(false);
        }
        if (
          verificationResponse.phoneNameExists === true &&
          verificationResponse.emailExists === false
        ) {
          let sanitized = SanitizeEmail(verificationResponse.phoneNameEmail);
          setSanitizedExistingEmail(sanitized);
          setOpenPhoneDialog(true);
          setDisableInputs(false);
          setShowLoadingSpinner(false);
        }
      });
      // removing temporarily
      // TODO : Remove ReCaptcha Permanently?
      //   } else {
      //     console.log("ReCaptcha not authorized.");
      //   }
      // })
      // .catch((error) => {
      //   console.error("Error validating ReCaptcha : ", error);
      //   showApiErrorToast();
      //   setDisableInputs(false);
      //   setShowLoadingSpinner(false);
      // });
      // });
      // });
    }
  };
  return (
    <Grid>
      <form
        onSubmit={handleSubmit(submitPersonalInfo)}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
            sx={{
              width: "100%",
            }}
          >
            <TextField
              name="firstName"
              label={t("registration.firstName")}
              size="small"
              // margin="normal"
              // required
              fullWidth
              disabled={disableInputs}
              autoFocus
              error={!!errors.firstName}
              helperText={errors.firstName ? errors.firstName.message : ""}
              data-cy="register-first-name"
              slotProps={{
                input: {
                  startAdornment: <PersonOutline sx={iconStyling} />,
                },
                htmlInput: {
                  ...register("firstName", {
                    required: {
                      value: true,
                      message: t("registration.firstNameRequired"),
                    },
                    pattern: {
                      value: /^[^\s].*$/,
                      message: t("registration.noSpace"),
                    },
                    validate: (value) => {
                      if (value.length >= 2) {
                        return true;
                      } else {
                        return t("registration.firstNameLengthError");
                      }
                    },
                  }),
                },
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
            sx={{
              width: "100%",
            }}
          >
            <TextField
              name="lastName"
              label={t("registration.lastName")}
              size="small"
              // margin="normal"
              // required
              fullWidth
              disabled={disableInputs}
              error={!!errors.lastName}
              helperText={errors.lastName ? errors.lastName.message : ""}
              data-cy="register-last-name"
              slotProps={{
                input: {
                  startAdornment: <PersonOutline sx={iconStyling} />,
                },
                htmlInput: {
                  ...register("lastName", {
                    required: {
                      value: true,
                      message: t("registration.lastNameRequired"),
                    },
                    pattern: {
                      value: /^[^\s].*$/,
                      message: t("registration.noSpace"),
                    },
                    validate: (value) => {
                      if (value.length >= 2) {
                        return true;
                      } else {
                        return t("registration.lastNameLengthError");
                      }
                    },
                  }),
                },
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
            sx={{
              width: "100%",
            }}
          >
            <Controller
              control={control}
              name="cellPhone"
              defaultValue={null}
              rules={{
                required: {
                  value: true,
                  message: t("registration.cellPhoneRequired"),
                },
                validate: (value) => {
                  if (value.replace(/\D/g, "").length === 10) {
                    return true;
                  } else {
                    return t("registration.cellPhoneValid");
                  }
                },
              }}
              render={({ field: __propsField }) => {
                const props = {
                  ...__propsField,
                  value: __propsField.value ?? null,
                };
                return (
                  <TextField
                    {...props}
                    label={t("registration.cellPhoneNumber")}
                    // required
                    fullWidth
                    size="small"
                    disabled={disableInputs}
                    error={!!errors.cellPhone}
                    helperText={
                      errors.cellPhone ? errors.cellPhone.message : ""
                    }
                    data-cy="register-phone-number"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        inputComponent: TextMaskPhone,
                        startAdornment: <PhoneIphoneIcon sx={iconStyling} />,
                      },
                    }}
                  />
                );
              }}
              data-cy="register-phone-number"
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
            sx={{
              width: "100%",
            }}
          >
            <TextField
              name="email"
              label={t("registration.emailAddress")}
              size="small"
              // margin="normal"
              // required
              fullWidth
              disabled={disableInputs}
              error={!!errors.email}
              helperText={errors.email ? errors.email.message : ""}
              data-cy="register-email"
              slotProps={{
                input: {
                  startAdornment: <EmailOutlined sx={iconStyling} />,
                },
                htmlInput: {
                  ...register("email", {
                    required: {
                      value: true,
                      message: t("registration.emailRequired"),
                    },
                    validate: (value) => {
                      const isValidEmail = /^\S+@\S+\.\S+$/.test(
                        (value || "").trim(),
                      );
                      return isValidEmail ? true : t("registration.emailValid");
                    },
                  }),
                },
              }}
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
            sx={{
              width: "100%",
            }}
          >
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={locale}
            >
              <Controller
                control={control}
                name="dob"
                defaultValue={null}
                rules={{
                  required: {
                    value: true,
                    message: t("registration.dateOfBirthRequired"),
                  },
                  validate: (value) => {
                    let minDate = moment().subtract(100, "years");
                    let maxDate = moment().subtract(14, "years");
                    if (value.toString() === "Invalid Date")
                      return t("registration.dateOfBirthInvalid");
                    if (value < minDate || value > maxDate) {
                      return t("registration.dateOfBirthInvalid");
                    }
                    return true;
                  },
                }}
                render={({ field: __propsField }) => {
                  const props = {
                    ...__propsField,
                    value: __propsField.value ?? null,
                  };
                  return (
                    <DesktopDatePicker
                      {...props}
                      id="dob"
                      label={t("registration.dateOfBirth")}
                      format={
                        countryCode === "AU" ? "dd/MM/yyyy" : "MM/dd/yyyy"
                      }
                      disableFuture
                      openTo="year"
                      views={["year", "month", "day"]}
                      disabled={disableInputs}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          error: !!errors.dob,
                          helperText: errors.dob ? errors.dob.message : "",
                          slotProps: {
                            inputLabel: {
                              shrink: true,
                            },
                          },
                        },
                      }}
                    />
                  );
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid
            container
            sx={{
              justifyContent: "center",
              paddingTop: "2em",
            }}
          >
            {showLoadingSpinner ? (
              <Grid>
                <TimeLoader />
              </Grid>
            ) : (
              <Grid>
                <BigButton variant="contained" color="primary" type="submit">
                  {t("registration.verifyPersonalInformation")}
                </BigButton>
              </Grid>
            )}
          </Grid>
          <input
            type="checkbox"
            id="call_me_out"
            name="call_me_out"
            style={{
              display: "none",
            }}
            tabIndex="-1"
            autoComplete="off"
            {...register("call_me_out", {})}
          />
        </Grid>
      </form>
      {/* Phone Dialog */}
      <Dialog
        open={openPhoneDialog}
        onClose={closePhoneDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {t("registration.phoneNumberInUse")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span
              style={{
                display: "inline-block",
                paddingBottom: 15,
              }}
            >
              {t("registration.continueToLogin")}
              {`${sanitizedExistingEmail} `}
              <strong>
                <RouterLink
                  onClick={() => {
                    toast.dismiss();
                  }}
                  to="account/login"
                >
                  {t("registration.returnToLogin")}
                </RouterLink>
              </strong>
            </span>
            <span
              style={{
                display: "inline-block",
              }}
            >
              {t("registration.verifyEmail")}
              <strong
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  toast.dismiss();
                  let verifyTextInfo = {
                    EmailAddress: existingEmail,
                    BrandIdentifier: brandIdentifier,
                    Silent: false,
                  };
                  if (countryCode === "USA") {
                    verifyText(verifyTextInfo) // usa
                      .then((response) => {
                        if (response.message === "Sent") openVerification();
                        else {
                          showApiErrorToast();
                          setDisableInputs(false);
                        }
                      })
                      .catch((error) => {
                        console.error(error);
                        if (
                          error.message.includes(
                            "User profile is missing Cell Phone Number.",
                          )
                        )
                          showContactUsToast();
                        else showApiErrorToast();
                        setDisableInputs(false);
                      });
                  } else if (countryCode === "AU") {
                    verifyEmail(verifyTextInfo)
                      .then((response) => {
                        // what is the success response?
                        if (response.message === "Sent") {
                          openVerification();
                        } else {
                          showApiErrorToast();
                          setDisableInputs(false);
                        }
                      })
                      .catch((error) => {
                        console.error(error);
                        // any special case error messages?
                        showApiErrorToast();
                        setDisableInputs(false);
                      });
                  }
                }}
              >
                {t("registration.here")}
              </strong>
            </span>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {/* Email Dialog */}
      <Dialog
        open={openEmailDialog}
        onClose={closeEmailDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {t("registration.emailInUse")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("registration.emailInUseInstructions")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenEmailDialog(false);
            }}
            sx={{
              marginRight: ".5em",
            }}
          >
            {t("registration.changeEmail")}
          </Button>
          <RouterLink
            style={{
              textDecoration: "none",
              color: "white",
            }}
            to={`account/forgot-password?email=${encodeURIComponent(getValues("email"))}`}
          >
            <Button variant="contained" color="primary">
              {t("registration.resetPassword")}
            </Button>
          </RouterLink>
        </DialogActions>
      </Dialog>
      {/* Verification Dialog */}
      <form>
        <Dialog
          open={openVerificationDialog}
          onClose={closeVerificationDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {t("registration.verificationCodeTitle")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("registration.verificationCodeDescription")}
            </DialogContentText>
            <TextField
              autoFocus
              variant="outlined"
              margin="dense"
              size="small"
              id="verificationCode"
              name="verificationCode"
              label={t("registration.verificationCode")}
              type="text"
              fullWidth
              error={!!errors.verificationCode}
              helperText={
                errors.verificationCode ? errors.verificationCode.message : ""
              }
              slotProps={{
                htmlInput: {
                  ...register("verificationCode", {
                    required: {
                      value: true,
                      message: t("registration.verificationCodeRequired"),
                    },
                    pattern: {
                      value: /^[0-9]{6,6}$/,
                      message: t("registration.verificationCodeInvalid"),
                    },
                  }),
                },
              }}
            />
            {verificationCodeIncorrect && (
              <Typography
                style={{
                  color: "red",
                  fontSize: "small",
                }}
              >
                {t("registration.verificationCodeIncorrect")}
              </Typography>
            )}
            {verificationCodeExpired && (
              <Typography
                style={{
                  color: "red",
                  fontSize: "small",
                }}
              >
                {t("registration.verificationCodeExpired")}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={validateVerificationCode}
              color="primary"
              type="submit"
            >
              {t("registration.submitVerificationCode")}
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </Grid>
  );
};
PersonalInformation.propTypes = {
  handleNext: PropTypes.func,
  UpdateUserInfo: PropTypes.func,
};
export default PersonalInformation;
